/**
 * Backend field names that switch on special behaviour in the crud modal fields.
 * Collected here so a renamed backend field fails loudly in one place instead of silently
 * dropping a validation. Long term these become column options (e.g. `fieldKind: "phone"`).
 */

export const PHONE_FIELD_NAMES = [
  "phone",
  "witness_phone",
  "first_responder_phone",
] as const;

export const SED_DATE_FIELD_NAMES = ["executed_on", "valid_until"] as const;

export const EMAIL_FIELD_NAME = "email";
export const PRICE_FIELD_NAME = "price";
export const TRIGGER_CLASS_NAME_FIELD_NAME = "trigger_class_name";
export const YOUTUBE_URL_FIELD_NAME = "youtube_video_url";
export const ANALOG_FLAG_FIELD_NAME = "is_analog";
export const REGISTERED_FLAG_FIELD_NAME = "is_registered";
export const PORTAL_REGISTERED_FLAG_FIELD_NAME = "is_portal_registered";
export const SCHEDULED_FIELD_NAME = "scheduled";
export const CREATE_SED_FOR_COMPANY_FIELD_NAME = "create_sed_for_company";
export const SUBJECT_SET_FIELD_NAME = "subject_set";
export const DEPARTMENT_SET_FIELD_NAME = "department_set";
export const STAFF_FIELD_NAME = "staff";
export const CATEGORY_FIELD_NAME = "category";
export const FAUX_OVERDUE_FIELD_NAME = "faux_overdue";

const includes = (names: readonly string[], fieldName?: string) =>
  fieldName !== undefined && names.includes(fieldName);

export const isPhoneField = (fieldName?: string) =>
  includes(PHONE_FIELD_NAMES, fieldName);
export const isSedDateField = (fieldName?: string) =>
  includes(SED_DATE_FIELD_NAMES, fieldName);
export const isEmailField = (fieldName?: string) =>
  fieldName === EMAIL_FIELD_NAME;
export const isPriceField = (fieldName?: string) =>
  fieldName === PRICE_FIELD_NAME;
